import React, { Component } from 'react';
import PropTypes from 'prop-types';

class BarLine extends Component {
  constructor(props) {
    super(props);
    this.state = {
      distribution: props.distribution,
      total: 0
    };
  }

  componentWillMount() {
    let sum = 0;
    this.state.distribution.forEach(item => {
      sum += item.driversQuantity;
    });
    this.setState({
      total: sum
    });
  }
  sizeBox(size, total) {
    const porc = (size / total) * 100;
    return `${Math.round(porc)}%`;
  }

  render() {
    const outOfRisk = this.props.language ? this.props.language.outOfRisk : '';
    const midleRisk = this.props.language ? this.props.language.midleRisk : '';
    const atRisk = this.props.language ? this.props.language.atRisk : '';
    return (
      <div className="main_summary_graph__color_item_container">
        {this.state.distribution.map((item, i) => (
          <div
            key={`graph-${i}`}
            style={{ width: this.sizeBox(item.driversQuantity, this.state.total) }}
            className={`main_summary_graph__color_item_${item.severity}`}
          >
            <div className="main_summary_graph__color_hover">
              <h6>
                {
                  item.severity == 'OUTOFRISK'
                  ? `${outOfRisk}`
                  : item.severity == 'MIDDLERISK'
                  ? `${midleRisk}`
                  : `${atRisk}`
                }
                {' '}
                <strong>{item.driversQuantity}</strong>
              </h6>
            </div>
          </div>
        ))}
      </div>
    );
  }
}

export default BarLine;



// WEBPACK FOOTER //
// ./source/client/components/common/graphs/barLine.jsx